export const ForgetPasswordLang = {
    header: 'برای بازیابی رمز عبور، ایمیل خود را وارد کنید. لینک بازیابی رمز عبور به ایمیل شما ارسال خواهد شد',
    send: 'ارسال',
    forget: 'فراموشی رمز عبور',
    success: 'لینک بازیابی رمز عبور به ایمیل شما ارسال شد',
    error: 'خطایی رخ داده است، مجددا تلاش کنید',
};
